import { ILogger } from "@ezhou/common";
import { PageProps } from "@ezhou/core";

import { OrganizationChildCrudDataGrid } from "../common/OrganizationChildCrudDataGrid";

import {
  dummyMappingDimensionValueRow,
  mappingDimensionValueColumns,
} from "./model/metaData";

export type MappingDimensionValuesProps = {
  parentKey: any;
  pageProps: PageProps;
  logger: ILogger;
};

export const MappingDimensionValues = (props: MappingDimensionValuesProps) => {
  const baseUrl = "mapping-dimension-values";
  const dataKey = "mappingDimensionValueId";

  const dataToBeFiltered = [
    "mappingDimension",
    "mappingDimensionName",
  ];

  const dataToBeFilteredForForm = [dataKey];

  return (
    <>
      <div>Values</div>
      <OrganizationChildCrudDataGrid
        pageProps={props.pageProps}
        logger={props.logger}
        dummyRow={dummyMappingDimensionValueRow}
        keyExpr={dataKey}
        isKeyAutoGenerated={true}
        baseUrl={baseUrl}
        parentKey={props.parentKey}
        dataToBeFiltered={dataToBeFiltered}
        formTitle="Add Value"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={false}
        allowDeleting={true}
        dataToBeFilteredForForm={dataToBeFilteredForForm}
        hideColumnChooser={true}
        hideSearchPanel={true}
        hideInactiveButton={true}
        columnConfigs={mappingDimensionValueColumns}
      />
    </>
  );
};
